import API, {APIRequestConfig} from "../API"
import setIfNotSet from "../../setIfNotSet"
import channel from "../../channel"
import version from "../../version"
import {getGraphError} from "../API/utils/errorHandler/getGraphError"
import getUrl from "./utils/getUrl"
import appendApolloClientValues from "./utils/appendApolloClientValues"
import {PB_FEATURES} from "./helpers/features"

export interface GraphRequest {
  query: any
  variables?: Record<string, any>
  operationName?: string
}

const graph = async ({query, variables, operationName}: GraphRequest, options: APIRequestConfig = {}) => {
  setIfNotSet(options, "isGraphQuery", true)
  setIfNotSet(options, "headers.x-pb-features", PB_FEATURES)
  setIfNotSet(options, "headers.x-pb-channel", channel)
  setIfNotSet(options, "headers.x-pb-version", version)
  await appendApolloClientValues(options)

  const {data} = await API.post(getUrl(), {query, variables, operationName}, options)

  if (data.errors) throw getGraphError(data.errors, operationName)

  return data.data
}

export default graph
export {getUrl}
